/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CrossResourceQueryRequestResourcesInner {
  /**
  * User-defined alias to reference this resource/snapshot in the query. Use this alias as a prefix for table names in your SQL query. 
  */
  'alias': string;
  /**
  * ID of the resource (database server) to query.
  */
  'resourceId': string;
  /**
  * ID of the snapshot to query from.
  */
  'snapshotId': string;
  /**
  * Name of the database within the resource to query. For example, a PostgreSQL server may have multiple databases. 
  */
  'databaseName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "alias",
      "baseName": "alias",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "snapshotId",
      "baseName": "snapshotId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "databaseName",
      "baseName": "databaseName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CrossResourceQueryRequestResourcesInner.attributeTypeMap;
  }

  public constructor() {
  }
}

